import React from 'react';

class InputTuKhoa extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }


  render() {
    return (
      <div className="input-group-show">
        <label className="ip-label">Từ khoá</label>
        <input type="text" name="searchKey" placeholder={ this.props.placehoderText } className="search-input" onChange={ this.onChange.bind(this) } />
      </div>
      );
  }
}

InputTuKhoa.defaultProps = {
  placehoderText: 'Nhập tên người đứng đơn hoặc số CMND để tìm kiếm...',
  onChange: function() {
    console.log('Please assign onChange function');
  }
}

export default InputTuKhoa;



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/form-timkiem/input-tukhoa.js